import { AcctMgmtPage } from 'src/views/clog/cia-company-admin'
import pathMap from 'src/paths/pathMap'

class AcctMgmtRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.CALISTA_ACCOUNT_MANAGEMENT,
        component: AcctMgmtPage
      }
    ]
  }
}

export default AcctMgmtRoute
